import { useState, useEffect } from 'react';

function CommentsTab({ 
  comments,
  commentTab,
  setCommentTab,
  commentStatusFilter,
  setCommentStatusFilter,
  searchComments,
  setSearchComments,
  currentCommentsPage,
  setCurrentCommentsPage,
  totalCommentsPages,
  loadComments,
  toggleHideComment,
  deleteComment,
  markViolation,
  clearViolation
}) {
  // Reload comments when tab changes
  useEffect(() => {
    loadComments(1);
  }, [commentTab]);

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-6">Quản lý Bình luận</h2>
      
      {/* Sub tabs */}
      <div className="flex gap-2 mb-6 border-b overflow-x-auto">
        {['all', 'violations', 'reported'].map(tab => (
          <button 
            key={tab} 
            onClick={() => { setCommentTab(tab); setCurrentCommentsPage(1); }}
            className={`px-4 py-2 font-semibold border-b-2 whitespace-nowrap ${
              commentTab === tab 
                ? (tab === 'all' ? 'border-blue-600 text-blue-600' : 'border-red-600 text-red-600') 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab === 'all' ? 'Tất cả' : tab === 'violations' ? 'Vi phạm' : 'Bị báo cáo'}
          </button>
        ))}
      </div>

      {/* Search and Filter */}
      {commentTab === 'all' && (
        <div className="mb-4 flex flex-col sm:flex-row gap-3">
          <input 
            type="text" 
            value={searchComments} 
            onChange={(e) => setSearchComments(e.target.value)} 
            placeholder="Tìm kiếm..." 
            className="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500" 
          />
          <select 
            value={commentStatusFilter} 
            onChange={(e) => setCommentStatusFilter(e.target.value)} 
            className="px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
          >
            <option value="all">Tất cả trạng thái</option>
            <option value="visible">Hiển thị</option>
            <option value="hidden">Đã ẩn</option>
            <option value="violation">Vi phạm</option>
          </select>
        </div>
      )}

      {/* Comments Table */}
      <div className="bg-white rounded-xl border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Người dùng</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Bình luận</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Prompt</th>
                {commentTab === 'violations' && (
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Lý do</th>
                )}
                {commentTab === 'reported' && (
                  <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Số báo cáo</th>
                )}
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Trạng thái</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Thời gian</th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Hành động</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {comments.length === 0 ? (
                <tr>
                  <td colSpan="8" className="px-4 py-8 text-center text-gray-500">
                    <span className="material-symbols-rounded text-4xl text-gray-300 block mb-2">comment</span>
                    Không có bình luận
                  </td>
                </tr>
              ) : comments.map(c => (
                <tr key={c.commentId} className="hover:bg-gray-50">
                  <td className="px-4 py-3">
                    <p className="font-semibold">@{c.user}</p>
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-sm max-w-xs truncate">{c.text}</p>
                    {c.isViolation && <p className="text-xs text-red-600 mt-1">⚠️ {c.violationReason}</p>}
                    {c.reportCount > 0 && <p className="text-xs text-orange-600 mt-1">📢 {c.reportCount} báo cáo</p>}
                  </td>
                  <td className="px-4 py-3">
                    <p className="text-sm max-w-xs truncate">{c.pinTitle}</p>
                  </td>
                  {commentTab === 'violations' && (
                    <td className="px-4 py-3 text-sm">{c.violationReason}</td>
                  )}
                  {commentTab === 'reported' && (
                    <td className="px-4 py-3 text-sm">{c.reportCount}</td>
                  )}
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                      c.isViolation ? 'bg-red-100 text-red-800' : 
                      c.isHidden ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'
                    }`}>
                      {c.isViolation ? 'Vi phạm' : c.isHidden ? 'Đã ẩn' : 'Hiển thị'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm">{new Date(c.createdAt).toLocaleDateString('vi-VN')}</td>
                  <td className="px-4 py-3 text-right">
                    <div className="flex items-center justify-end gap-2">
                      <button 
                        onClick={() => toggleHideComment(c.pinId, c.commentId)} 
                        className={`px-3 py-1 text-xs font-semibold rounded-lg transition-colors ${
                          c.isHidden ? 'text-green-600 hover:bg-green-50' : 'text-orange-600 hover:bg-orange-50'
                        }`}
                      >
                        {c.isHidden ? 'Hiện' : 'Ẩn'}
                      </button>
                      {!c.isViolation ? (
                        <button 
                          onClick={() => markViolation(c.pinId, c.commentId)} 
                          className="px-3 py-1 text-xs font-semibold text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        >
                          Đánh dấu
                        </button>
                      ) : (
                        <button 
                          onClick={() => clearViolation(c.pinId, c.commentId)} 
                          className="px-3 py-1 text-xs font-semibold text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                        >
                          Xóa đánh dấu
                        </button>
                      )}
                      <button 
                        onClick={() => deleteComment(c.pinId, c.commentId)} 
                        className="px-3 py-1 text-xs font-semibold text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                      >
                        Xóa
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {totalCommentsPages > 1 && (
        <div className="mt-4 flex items-center justify-between">
          <p className="text-sm text-gray-600">Trang {currentCommentsPage} / {totalCommentsPages}</p>
          <div className="flex gap-2">
            <button 
              onClick={() => { setCurrentCommentsPage(p => Math.max(1, p - 1)); loadComments(currentCommentsPage - 1); }} 
              disabled={currentCommentsPage === 1} 
              className="px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Trước
            </button>
            <button 
              onClick={() => { setCurrentCommentsPage(p => Math.min(totalCommentsPages, p + 1)); loadComments(currentCommentsPage + 1); }} 
              disabled={currentCommentsPage === totalCommentsPages} 
              className="px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Sau
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CommentsTab;
